import { render, staticRenderFns } from "./DropdownFilterProductCategory.vue?vue&type=template&id=8db27a38&"
import script from "./DropdownFilterProductCategory.vue?vue&type=script&lang=js&"
export * from "./DropdownFilterProductCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8db27a38')) {
      api.createRecord('8db27a38', component.options)
    } else {
      api.reload('8db27a38', component.options)
    }
    module.hot.accept("./DropdownFilterProductCategory.vue?vue&type=template&id=8db27a38&", function () {
      api.rerender('8db27a38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/DropdownFilterProductCategory.vue"
export default component.exports